module.exports = __webpack_public_path__ + "img/heart.e27f6a8a.svg";